import { getOuListMember } from '@/api/alarm';
import { CustomFilter, Form, Input, Paging, Select, Table, useAsync, usePaging } from '@maxtropy/components';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import {
  apiV2DeviceAlarmPushStrategyPageDevicePost,
  apiV2DeviceAlarmPushStrategyPageDeviceV2Post,
} from '@maxtropy/device-customer-apis-v2';
import { deviceColumns } from './util';

interface FilterParams {
  name?: string;
  ouId?: number;
}

export interface ISelectDeviceModal {
  selectRecord?: any;
  deviceVisible: boolean;
  setDeviceSeletedIds: React.Dispatch<React.SetStateAction<number[]>>;
  deviceSeletedIds: number[];
}

const SelectDeviceModal: FC<ISelectDeviceModal> = props => {
  const { selectRecord, deviceVisible, setDeviceSeletedIds, deviceSeletedIds } = props;
  const [searchParams, setSearchParams] = useState<FilterParams>();
  const ou = useAsync(getOuListMember, []);
  const [form] = Form.useForm();
  const pagingInfo = usePaging(100);
  const { pageOffset, pageSize, setTotalCount, setPageOffset } = pagingInfo;

  // 监管设备分页
  const { data: deviceList, loading } = useRequest(
    async () =>
      apiV2DeviceAlarmPushStrategyPageDeviceV2Post({
        ...searchParams,
        ruleId: selectRecord.ruleId,
        page: pageOffset,
        size: pageSize,
      }).then(res => {
        setTotalCount(res.total ?? 0);
        return res.list;
      }),
    {
      ready: !!deviceVisible && !!selectRecord,
      refreshDeps: [deviceVisible, searchParams, pageOffset, pageSize, selectRecord],
    }
  );

  const ouOptions = useMemo(() => {
    if (ou.length !== 0) {
      return ou.map(i => ({ label: i.name, value: i.id }));
    }
  }, [ou]);

  const onFinish = (value: FilterParams) => {
    setSearchParams(value);
    setPageOffset(1);
  };

  const onReset = () => {
    setSearchParams({});
    form.setFieldsValue({
      name: undefined,
      ouId: undefined,
    });
    setPageOffset(1);
  };

  const filters = (
    <CustomFilter
      colSpan={8}
      form={form}
      onFinish={val => {
        onFinish(val as FilterParams);
      }}
      onReset={onReset}
    >
      <Form.Item name="name" label="编号/名称">
        <Input placeholder="请输入编号或名称查询" />
      </Form.Item>
      <Form.Item name="ouId" label="运营单元">
        <Select
          style={{ width: '100%' }}
          placeholder="请选择"
          options={ouOptions}
          showSearch
          optionFilterProp="label"
        />
      </Form.Item>
    </CustomFilter>
  );

  useEffect(() => {
    if (!selectRecord) return;
    setDeviceSeletedIds(selectRecord?.deviceIdList ?? []);
  }, [selectRecord]);

  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setDeviceSeletedIds(selectedRowKeys as number[]);
    },
    selectedRowKeys: deviceSeletedIds,
  };

  return (
    <>
      {filters}
      <Table
        loading={loading}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
        sticky
        scroll={{ y: 300 }}
        rowKey="deviceId"
        columns={deviceColumns}
        dataSource={deviceList}
        showSelectedCount
        selectedCount={(deviceSeletedIds ?? []).length}
      >
        <Paging pagingInfo={pagingInfo} />
      </Table>
    </>
  );
};

export default SelectDeviceModal;
